// test1349
(1349 && 0);
